
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("lreLE", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $f9b7931d46cac9c2$export$2cd8252107eb640b; });
// ====================================================================================
// tabs.module
// ====================================================================================

var $jG4hL = parcelRequire("jG4hL");
const $f9b7931d46cac9c2$export$2cd8252107eb640b = ()=>{
    let attempts = 0;
    // if document.ready needed
    const whenComplete = ()=>{
        if (attempts > 30) return;
        attempts += 1;
        if (document.readyState === "complete") (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))('section [role="tab"]').on("click", function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(this).parent().parent().find("button.active").removeClass("active");
            (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(this).addClass("active");
            const tabsContainer = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(this).closest('[role="tablist"]').next();
            const tabId = this.getAttribute("aria-controls");
            const tabsActivePrev = tabsContainer.find(".tab-pane.show").not(`[data-target="${tabId}"]`);
            const tabsActiveNext = tabsContainer.find(`.tab-pane[id="${tabId}"]`);
            tabsActivePrev.removeClass("show").removeClass("active");
            tabsActiveNext.addClass("active").addClass("show");
        });
        else setTimeout(function() {
            whenComplete();
        }, 400);
    };
    whenComplete();
};

});


//# sourceMappingURL=tabs.module.80742a05.js.map
